var map = {
	"./Home.vue": [
		"bb51",
		"chunk-741f5406",
		"chunk-5024ffa2"
	],
	"./grafici.vue": [
		"cd2e",
		"chunk-741f5406",
		"chunk-17fce38f"
	],
	"./regionali.vue": [
		"a298",
		"chunk-741f5406",
		"chunk-6ed22197",
		"chunk-2d207bc6"
	],
	"./storico.vue": [
		"953e",
		"chunk-741f5406",
		"chunk-6ed22197",
		"chunk-2d0e57a4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;